import {
  ADD_BILLINGCONSOLIDATEDINVOICE,
  ADD_BILLINGGENERATEINVOICE,
  ADD_BILLINGPRICEDETAILS,
  ADD_BILLINGREQUESTAPPROVAL,
  GET_BILLINGCONSOLIDATEDINVOICE,
  GET_BILLINGEXTRACHARGECALCULATION,
  GET_BILLINGINVOICEDETAILS,
  GET_BILLINGLIST,
  GET_BILLINGPRICEDETAILS,
  GET_CONSOLIDATE_INVOICE_MATRIX,
  GET_FINAL_INVOICE,
  ADD_BILLINGREQUESTAPPROVALLINK
} from "resources/actionTypes";

export function getBillingList(payload) {
  return {
    type: GET_BILLINGLIST.GET_BILLINGLIST_REQUESTED,
    payload: payload,
  };
}

export function clearBillingList() {
  return {
    type: GET_BILLINGLIST.GET_BILLINGLIST_CLEARED,
  };
}
export function clearFinalInvoice(){
  return{
    type:GET_FINAL_INVOICE.GET_FINAL_INVOICE_CLEARED,
  }
}
//Price Invoice Details
export function getBillingInvoiceDetails(id, type) {
  const payloadData = {
    id: id,
    type: type,
  };
  return {
    type: GET_BILLINGINVOICEDETAILS.GET_BILLINGINVOICEDETAILS_REQUESTED,
    payload: payloadData,
  };
}

//Price Invoice Details
export function getBillingPrice(payload) {
  return {
    type: GET_BILLINGPRICEDETAILS.GET_BILLINGPRICEDETAILS_REQUESTED,
    payload: payload,
  };
}

export function getBillingCharges(payload) {
  const payloadData = {
    tripId: payload?.tripId,
    extraTime: payload?.extraTime,
    extraDistance: payload?.extraDistance,
  };

  return {
    type: GET_BILLINGEXTRACHARGECALCULATION.GET_BILLINGEXTRACHARGECALCULATION_REQUESTED,
    payload: payloadData,
  };
}

export function addBillingPrice(payload, id, handleNavigate) {
  const payloadData = {
    obj: payload,
    id: id,
    navigate: handleNavigate,
  };

  return {
    type: ADD_BILLINGPRICEDETAILS.ADD_BILLINGPRICEDETAILS_REQUESTED,
    payload: payloadData,
  };
}

export function addBillingRequestApproval(payload, toggle) {
  const payloadData = {
    dataObj: payload,
    toggle: toggle,
  };
  return {
    type: ADD_BILLINGREQUESTAPPROVAL.ADD_BILLINGREQUESTAPPROVAL_REQUESTED,
    payload: payloadData,
  };
}

export function addBillingConsolidatedInvoice(payload, billingListPayload, handleTotalAmount) {
  const payloadData = {
    dataObj: payload,
    billingListPayload: billingListPayload,
    handleTotalAmount: handleTotalAmount
  };
  return {
    type: ADD_BILLINGCONSOLIDATEDINVOICE.ADD_BILLINGCONSOLIDATEDINVOICE_REQUESTED,
    payload: payloadData,
  };
}

export function getBillingConsolidatedInvoiceDetails(id, type) {
  const payload = {
    id:id,
    type:type
  }
  return {
    type: GET_BILLINGCONSOLIDATEDINVOICE.GET_BILLINGCONSOLIDATEDINVOICE_REQUESTED,
    payload: payload,
  };
}

export function generateInvoice(payload) {
  return {
    type: ADD_BILLINGGENERATEINVOICE.ADD_BILLINGGENERATEINVOICE_REQUESTED,
    payload: payload,
  };
}

export function getConsolidateInvoiceMatrix(id,type) {
const payload = {
  id:id,
 type:type
}
  return {
    type: GET_CONSOLIDATE_INVOICE_MATRIX.GET_CONSOLIDATE_INVOICE_MATRIX_REQUESTED,
    payload: payload,
  };
}

export function getFinalInvoice(payload){
  return {
    type:GET_FINAL_INVOICE.GET_FINAL_INVOICE_REQUESTED,
    payload:payload,
  }
}

// Add billing Request Link
export function addBillingRequestApprovalLink (payload, toggle) {
  const payloadData = {
    dataObj: payload,
    toggle: toggle,
  };
  return {
    type: ADD_BILLINGREQUESTAPPROVALLINK.ADD_BILLINGREQUESTAPPROVALLINK_REQUESTED,
    payload: payloadData,
  };
}
